export const UNAUTHORIZED_POPUP_SHOW = "UNAUTHORIZED_POPUP/SHOW";
export const UNAUTHORIZED_POPUP_CLEAR = "UNAUTHORIZED_POPUP/CLEAR";
